import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

/**
 * A consistent section header component for use within pages
 * 
 * @param {Object} props - Component props
 * @param {String} props.title - The section title
 * @param {String} props.subtitle - Optional subtitle text
 * @param {Node} props.action - Optional action component (usually a button)
 * @param {Boolean} props.divider - Whether to show a divider after the header
 * @param {Object} props.sx - Additional styling
 */
const SectionHeader = ({
  title,
  subtitle,
  action,
  divider = true,
  sx = {}
}) => {

  return (
    <Box sx={{ width: '100%', mb: divider ? 3 : 2, ...sx }}>
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: subtitle ? 0.5 : divider ? 1 : 0 
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        
        {action && (
          <Box>
            {action}
          </Box>
        )}
      </Box>
      
      {subtitle && (
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ mb: divider ? 1 : 0 }}
        >
          {subtitle}
        </Typography>
      )}
      
      {divider && <Divider sx={{ mb: 2 }} />}
    </Box>
  );
};

export default SectionHeader;